import { api } from "@/lib/api";
import type { Service, ServiceCreate, ServiceInput } from "./types";

export const servicesApi = {
  list: () => api.get<Service[]>("/services"),
  register: (payload: ServiceCreate) => api.post<Service>("/services", payload),
  update: (audience: string, payload: ServiceInput) =>
    api.put<Service>(`/services/${audience}`, payload),
  setEnabled: (audience: string, enabled: boolean) =>
    api.put<Service>(`/services/${audience}/enabled`, { enabled }),
};

export const serviceKeys = {
  all: ["services"] as const,
  list: () => [...serviceKeys.all, "list"] as const,
};
